import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./en";
import vi from "./vi";

// Ưu tiên locale trên URL. Không ghi localStorage/cookie tại đây —
// cookie ngôn ngữ chỉ được lưu khi functional === true (xem langCookie.js).
const pathLang = typeof window !== "undefined"
  ? window.location.pathname.split("/")[1]
  : "";

const lng = pathLang === "en" || pathLang === "vi" ? pathLang : "en";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      vi: { translation: vi },
    },

    lng,

    fallbackLng: "en",

    supportedLngs: ["en", "vi"],

    interpolation: {
      escapeValue: false,
    },

    returnEmptyString: false,
  });

export default i18n;
